import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { IOption } from 'src/app/interface/option';

export type DropdownType = 'plain' | 'dashboard-months' | 'with-header';

@Component({
  selector: 'app-single-select-dropdown',
  template: `
    <div #dropdown class="single-select-dropdown-container"
      [ngStyle]="{
        'width': dropdownWidth,
        'min-width': dropdownMinWidth
      }"
      [ngClass]="{
        'label-visible' : label !== '',
        'dashboard-months': dropdownType === 'dashboard-months'
      }" >

      <span class='label'>{{ label }}</span>

      <div class="single-select-dropdown" (click)="toggleDropdown()"
        [ngStyle]="{ 'height': dropdownHeight }"
        [ngClass]="{
          'invalidField' : canValidate && (!selectedOption?.value || selectedOption?.value === ''),
          'disabled': disabled,
          'focused': isOpen,
        }">
        <span class='selected-option'>{{ selectedOption ? selectedOption.value : placeholderText }}</span>
        <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
      </div>

      <div class="select-menu" *ngIf="isOpen && !disabled" 
        [ngStyle]="{
          'min-width': dropdownMenuMinWidth ? dropdownMenuMinWidth : '100%',
          'max-height': dropdownMenuMaxHeight ? dropdownMenuMaxHeight : '150px',
          'right': menuAllign === 'right' ? '0px' : '',
        }">
        <div class="menu-header" *ngIf="dropdownType === 'with-header'">{{ placeholderText }}</div>
        <div class="menu-option" *ngFor="let option of elements" (click)="selectOption(option)"
          [ngClass]="{
            'selected' : selectedOption?.value === option.value,
            'option-border': isOptionBorderVisible
          }"
        >
          {{option.value}}
        </div>
      </div>

      <!-- Old implementation -->
      <!-- <div class="select-menu" *ngIf="isOpen && !disabled" 
        [ngStyle]="{
          'min-width': dropdownMenuMinWidth ? dropdownMenuMinWidth : '100%',
          'max-height': dropdownMenuMaxHeight ? dropdownMenuMaxHeight : '150px',
          'right': menuAllign === 'right' ? '0px' : '',
          'top': menuPosition, // this is difference
        }">
        <div class="menu-header" *ngIf="dropdownType === 'with-header'">{{ placeholderText }}</div>
        <div class="menu-option" *ngFor="let option of elements" (click)="selectOption(option)"
          [ngClass]="{
            'selected' : selectedOption?.value === option.value,
            'option-border': isOptionBorderVisible
          }"
        >
          {{option.value}}
        </div>
      </div> -->

      <div *ngIf="canValidate && (!selectedOption?.value || selectedOption?.value === '')" class="form-control-error">{{ errorMessage }}</div>
    </div>
  `,
  styleUrls: ['./single-select-dropdown.component.scss']
})
export class SingleSelectDropdownComponent {
  @Input() label: string = '';
  @Input() errorMessage: string = 'Required field';
  @Input() placeholderText: string = '';
  @Input() elements: IOption[] = [];
  @Input() canValidate!: boolean;
  @Input() disabled: boolean = false;
  @Input() isOpen: boolean = false;
  @Input() dropdownType: DropdownType = 'plain';
  @Input() dropdownMenuMinWidth!: string | null;
  @Input() dropdownMenuMaxHeight!: string | null;
  @Input() dropdownWidth: string = '100%';
  @Input() dropdownMinWidth: string = 'max-content';
  @Input() dropdownHeight: string = '50px';


  @Input() menuAllign: 'left' | 'right' = 'right';
  @Input() isOptionBorderVisible: boolean = false;

  @Input('preselectedOption') set preselectedOption(value: IOption | null) {
    this.selectedOption = value;
  }

  @Output() selectionChanged = new EventEmitter<IOption>();

  // Props used to close a dropdown when the user clicks somewhere outside
  @ViewChild('dropdown') dropdownRef!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  onOutsideClick(event: any): void {
     if (!this.dropdownRef?.nativeElement.contains(event.target) && this.isOpen) {
      this.isOpen = false;
     }
  }

  selectedOption!: IOption | null;
  menuPosition: string = 'unset';

  ngOnInit(): void {
    // Preselect value
    if (this.preselectedOption != null) {
      this.selectedOption = this.preselectedOption;
    }
    // this.calculateMenuPosition();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: IOption) {
    if (this.disabled) {
      return;
    }
    this.selectedOption = option;
    this.toggleDropdown();

    this.selectionChanged.emit(this.selectedOption);
  }

  calculateMenuPosition() {
    let prop = '';
    let value: number = 0;

    if (this.dropdownHeight.includes('px')) {
      prop = 'px';
      value = Number(this.dropdownHeight.replace('px', '')) ?? 0;
    } else if (this.dropdownHeight.includes('rem')) {
      prop = 'rem';
      value = Number(this.dropdownHeight.replace('rem', '')) ?? 0;
    }

    if (value) {
      if (this.dropdownType === 'with-header') {
        this.menuPosition = ((value / 100) * 120).toString() + prop;
      } else {
        // TODO: maybe needed in the future
        // this.menuPosition = ((value / 100) * 166).toString() + prop;
      }
    }
  }
}